import register from 'preact-custom-element'
import PlpNative from 'snippets/plp-native/plp-native'

let devtools

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require , no-unused-vars
  devtools = require('preact/devtools')
}

if (!customElements.get('plp-native')) {
  register(PlpNative, 'plp-native')
}
